import { render, staticRenderFns } from "./TraxUiDataTable.vue?vue&type=template&id=2449dd98"
import script from "./TraxUiDataTable.vue?vue&type=script&lang=js"
export * from "./TraxUiDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports